import { ReloadOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import { PropsWithChildren } from 'react'
import {
  ErrorBoundary as ErrorBoundaryWrapper,
  FallbackProps,
} from 'react-error-boundary'

function fallbackRender({ error, resetErrorBoundary }: FallbackProps) {
  return (
    <div
      id='error-page'
      className='flex flex-col justify-center items-center h-screen max-h-full max-w-3xl mx-auto'
    >
      <h1 className='text-4xl font-bold mb-8'>模块运行异常</h1>
      {/* <p className="mb-4">渲染时出了点问题</p> */}
      <p className='flex items-center mb-3'>
        若
        <Button
          icon={<ReloadOutlined />}
          style={{ fontSize: 12, margin: '0 8px' }}
          size='small'
          onClick={() => window.location.reload()}
        >
          刷新页面
        </Button>
        后无法恢复, 请联系管理员
      </p>
      <p className='text-slate-400'>
        <i>异常信息: {error.message || 'UNKNOWN'}</i>
      </p>
    </div>
  )
}

function ErrorBoundary({ children }: PropsWithChildren) {
  return (
    <ErrorBoundaryWrapper fallbackRender={fallbackRender}>
      {children}
    </ErrorBoundaryWrapper>
  )
}

export default ErrorBoundary
